import { render } from "./FormDeposito.vue?vue&type=template&id=e8e0e13a"
import script from "./FormDeposito.vue?vue&type=script&lang=js"
export * from "./FormDeposito.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__